<template>
  <div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
        {{allertMessage}}
    </b-alert>
    <b-alert :show="showReloadAlert" dismissible fade variant="primary" class="content-update-alert">New content is available, please refresh.
      <base-button size="sm" class="custom-size ml pull-right" v-on:click="reloadPage" outline type="default">Reload</base-button>
    </b-alert>
    <modal :show.sync="updateModal"
            @close="clearModal"
            body-classes="p-0"
            modal-classes="modal-dialog-centered modal-sm">
            <template slot="header">
                <h5 class="modal-title text-center" id="exampleModalLabel">Updating info</h5>
            </template>
            <div class="modal-body">Updates are available</div>
    </modal>
    <preloader v-if="showPreloader"></preloader>
    <NavBar></NavBar>
    <router-view></router-view>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import NavBar from './NavBar'
import alertMixin from './mixins/alertMixin'
import locationMixin from './mixins/locationMixin'
import jobsMixin from './mixins/jobsMixin'
import cacheStorageMixin from './mixins/cacheStorageMixin'
import timestampMixinMixin from './mixins/timestampMixin'
export default {
  data () {
    return {
      posts: [],
      intervalid: '',
      updateModal: null,
      updateInterval: 600000,
      showPreloader: false,
      showReloadAlert: false
    }
  },
  mounted () {
    this.checkMode()
    this.getJobs()
    this.checkUpdates()
    this.checkAndSaveLocationData()
    this.askForNotification()
    this.addEventSWUpdated()
  },
  computed: {
    token () {
      return this.$store.state.user.token
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  methods: {
    reloadPage () {
      window.location.reload(true)
    },
    addEventSWUpdated () {
      let self = this
      document.addEventListener('swUpdated', function (e) {
        self.showReloadAlert = true
      }, false)
    },
    async askForNotification () {
      const permission = await window.Notification.requestPermission()
      // value of permission can be 'granted', 'default', 'denied'
      // granted: user has accepted the request
      // default: user has dismissed the notification permission popup by clicking on x
      // denied: user has denied the request.
      if (permission !== 'granted') {
        alert('Permission not granted for Notification')
        throw new Error('Permission not granted for Notification')
      }
    },
    clearModal () {
      console.log(1)
    },
    refresh () {
      this.tokenRefresh()
    },
    tokenRefresh () {
      let self = this
      this.$store.dispatch('refreshToken', this.$store.state.user.token)
        .then(response => {
          let responseToken = response.data.result.token
          if (responseToken) {
            let now = Date.now()
            self.$store.commit('tokenChange', response.data.result.token)
            self.$store.commit('tokenRefreshTime', now)
            console.log('Token has been refreshed')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    checkUpdates () {
      let self = this
      let updateInterval = +process.env.VUE_APP_JOB_INTERVAL_UPDATE || this.updateInterval
      this.intervalUpdate = setInterval(function () {
        if (self.isOnline) self.getJobs()
      }, updateInterval)
    },
    checkMode () {
      let self = this
      let tokenCheckInterval = +process.env.VUE_APP_TOKEN_TIME_CHECK || 15000
      this.intervalid = setInterval(function () {
        if (self.isLogin) self.tokenTimeCheck()
      }, tokenCheckInterval)
    },
    tokenTimeCheck () {
      let tokenCheckInterval = +process.env.VUE_APP_TOKEN_TIME_CHECK || 15000
      let currentTime = this.getCurrentTime()
      let tokenTimeRefresh = Math.round(this.$store.state.user.tokenRefreshTime / 1000)
      if (!tokenTimeRefresh) return
      if ((currentTime - tokenTimeRefresh) > 60 * 60 * 24 * 7 - 2 * tokenCheckInterval) this.tokenRefresh()
    }
  },
  mixins: [alertMixin, jobsMixin, locationMixin, cacheStorageMixin, timestampMixinMixin],
  beforeDestroy () {
    document.removeEventListener('swUpdated')
    clearInterval(this.intervalid)
    clearInterval(this.intervalUpdate)
  },
  components: {
    NavBar,
    Modal
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .ml {
    margin-left: 15px;
  }
</style>
